module.exports = __webpack_public_path__ + "static/media/login-bg.c1360ec6.jpg";